import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable, shareReplay } from "rxjs";
import { NewCompanyPayloadInterface } from "../_utils/company.interface";

@Injectable({
	providedIn: "root",
})
export class CompanyDataService {
	private basePath: string = `${environment.url}/api/Dealer/`;
	private basePathAccessRole: string = `${environment.url}/api/DealerRepAccessRole/`;

	constructor(private http: HttpClient) {}

	getListing(
		limit: number,
		offset: number,
		text: string,
		columnIndex: number,
		sortDirection: string,
		statusList: string[],
	) {
		return this.http.post<any>(`${this.basePath}GetListing/`, {
			limit,
			offset,
			text,
			columnIndex,
			sortDirection,
			statusList,
		});
	}

	deactivateCompany(id: string) {
		return this.http.post<any>(`${this.basePath}Deactivate/${id}`, {});
	}

	activateCompany(id: string) {
		return this.http.post<any>(`${this.basePath}Activate/${id}`, {});
	}

	createCompany(reqObj: NewCompanyPayloadInterface) {
		return this.http.post<any>(`${this.basePath}Create`, reqObj);
	}

	updateCompany(reqObj, id: string) {
		return this.http.post<any>(`${this.basePath}Update/${id}`, reqObj);
	}

	getBankSelection() {
		return this.http.get<any>(`${this.basePath}GetBankSelection`);
	}

	getVehicleTypeAccessSelection() {
		return this.http.get<any>(`${this.basePath}GetVehicleTypeAccessSelection`);
	}

	getDealerSelection() {
		return this.http.get<any>(`${this.basePath}GetDealerSelection`);
	}

	getDealerByDealerRepId(id: string) {
		return this.http.get<any>(`${this.basePath}GetDealerByDealerRepId/${id}`);
	}

	getVehicleTypeAccessByDealerId(id: string) {
		return this.http.get<any>(`${this.basePath}GetVehicleTypeAccessByDealerId/${id}`);
	}
}
